/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { IoMdAdd } from "react-icons/io";
import { Modal } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import {
  GetAllBlockList,
  DeleteBlockList,
  UpdateBlockList,
} from "../Features/Blocklist";
import { RootState, AppDispatch } from "../Appstore/store";
import AddallowIPmodal from "../Components/AddallowIPmodal";
import UpdateAllowIP from "../Components/UpdateAllowIP";
import { setIsLoading } from "../Features/loadingSlice";
import { toast } from "sonner";
import { RenderPaginationButtons } from "../Components/Paginations";
import HelpText from "../Components/HelpText";
import AddBlockListModal from "../Components/AddblocklistModal";
import UpdateBlockListModal from "../Components/UpdateBlockListModal";
import { formatDate } from "../helper";

function Blocklist() {
  const [showAddAllowIpModal, setshowAddAllowIpModal] =
    useState<boolean>(false);
  const [showUpdateAllowIpModal, setUpdateAllowIpModal] =
    useState<boolean>(false);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const limit = 10;
  const [showDeleteModal, setShowDeleteModal] = useState<boolean>(false);
  const [selectedId, setSelectedId] = useState<number | null>(null);
  const [search, setSearch] = useState<string>("");
  const dispatch = useDispatch<AppDispatch>();

  const { blocklistdata, info, loading } = useSelector(
    (state: RootState) => state.blocklist
  );

  const [debouncedSearch, setDebouncedSearch] = useState<string>(search);
  const [currentblockListData, setcurrentblockListData] = useState<{
    number: string;
    campaign_id: number[];
  } | null>(null);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearch(search.trim());
    }, 700);

    return () => {
      clearTimeout(handler);
    };
  }, [search]);

  useEffect(() => {
    dispatch(
      GetAllBlockList({ search: debouncedSearch, page: currentPage, limit })
    );
  }, [dispatch, debouncedSearch, currentPage, limit]);

  const openDeleteModal = (id: number) => {
    setSelectedId(id);
    setShowDeleteModal(true);
  };

  const closeDeleteModal = () => {
    setShowDeleteModal(false);
    setSelectedId(null);
  };

  useEffect(() => {
    if (currentPage > info?.total_page!) setCurrentPage(info?.total_page || 1);
  }, [info]);

  const confirmDelete = async () => {
    if (selectedId !== null) {
      dispatch(setIsLoading(true));
      const resp: any = await dispatch(DeleteBlockList({ id: selectedId }));
      if (resp?.payload?.status === "success")
        toast.success(resp?.payload?.message || "");
      else toast.error(resp?.payload?.message || "");
      setTimeout(() => {
        dispatch(setIsLoading(false));
      }, 500);
      dispatch(GetAllBlockList({ search: "", page: 1, limit: 10 }));
    }
    closeDeleteModal();
  };

  const addAllowIprecord = () => {
    setshowAddAllowIpModal(true);
  };

  const closeaddAllowIprecordModal = () => {
    setshowAddAllowIpModal(false);
  };

  const UpdateIprecord = (id: number) => {
    setSelectedId(id);
    const ipData = blocklistdata.find((item) => item.id === id);

    if (ipData) {
      setcurrentblockListData({
        number: ipData.number || "",
        campaign_id: ipData.blocklist_numbers_campaigns?.map(
          (item: any) => item?.campaign_id
        ),
      });
    }
    setUpdateAllowIpModal(true);
  };

  const closeUpdateAllowIprecordModal = () => {
    setUpdateAllowIpModal(false);
    setcurrentblockListData(null);
  };

  const handlePageChange = (page: number) => {
    if (page > 0 && page <= (info?.total_page || 1)) {
      setCurrentPage(page);
    }
  };

  return (
    <>
      <div className="wrapper">
        <div className="content-wrapper">
          <section className="content">
            <div className="container-fluid">
              <div className="card mt-4">
                <div className="card-header bg-white p-3 d-md-flex justify-content-md-between align-items-center">
                  <h2 className="w-100 text-md-start text-center mb-md-2 mb-3 fs-3">
                    Block List
                  </h2>
                  <div className="d-sm-flex justify-content-between align-items-center mb-md-0 mb-3">
                    <div className="input-group input-group-sm pe-sm-3 mb-sm-0 mb-3 search-input">
                      <input
                        type="search"
                        name="table_search"
                        className="form-control float-right height-40px shadow-none"
                        placeholder="Search"
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                      />
                      <div className="input-group-append">
                        <button
                          type="submit"
                          className="btn border cursor-pointer-none"
                        >
                          <i className="fas fa-search" />
                        </button>
                      </div>
                    </div>
                    <div>
                      <div className="">
                        <button
                          data-tooltip-id="Add_Btn"
                          onClick={addAllowIprecord}
                          className="border-0  bg-button btn btn-primary text-white rounded-0 text-secondary w-100 px-2 py-2 fw-semibold d-flex justify-content-center align-items-center"
                        >
                          <IoMdAdd className="fs-4" />
                          <HelpText id="Add_Btn" content="Add Block List" />
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="card-body  p-0">
                  <>
                    <div className="table-responsive">
                      <table className="table table-hover table-bordered text-nowrap">
                        <thead>
                          <tr>
                            <th
                              className="ps-3 sr-no"
                              style={{ minWidth: 200 }}
                            >
                              SR No
                            </th>
                            <th
                              className="text-center"
                              style={{ minWidth: 200 }}
                            >
                              Numbers
                            </th>
                            <th
                              className="text-center"
                              style={{ minWidth: 200 }}
                            >
                              Campaign
                            </th>
                            <th
                              className="text-center"
                              style={{ minWidth: 200 }}
                            >
                              Block By
                            </th>
                            <th
                              className="text-center"
                              style={{ minWidth: 200 }}
                            >
                              User
                            </th>
                            <th
                              className="text-center"
                              style={{ minWidth: 200 }}
                            >
                              Created At
                            </th>
                            <th
                              className="text-center"
                              style={{ minWidth: 200 }}
                            >
                              Updated At
                            </th>
                            <th
                              className="text-center action"
                              style={{ width: 200 }}
                            >
                              Actions
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {loading ? (
                            <tr>
                              <td colSpan={8} height={100}>
                                <div className="text-center">
                                  <div className="loader"></div>
                                </div>
                              </td>
                            </tr>
                          ) : !blocklistdata || blocklistdata.length === 0 ? (
                            <tr>
                              <td colSpan={8} height={50}>
                                <div className="text-center">
                                  <p className="mb-0 fs-5 fw-semibold">
                                    No data found
                                  </p>
                                </div>
                              </td>
                            </tr>
                          ) : (
                            blocklistdata.map((item, index) => (
                              <tr key={index}>
                                <td className="ps-3">
                                  {(currentPage - 1) * limit + index + 1}
                                </td>
                                <td className="text-center">{item?.number}</td>
                                <td>
                                  <div className="w-100">
                                    {item?.blocklist_numbers_campaigns?.map(
                                      (campaign, i) => (
                                        <div
                                          className="w-100 d-flex justify-content-center"
                                          style={{
                                            borderBottom:
                                              i ===
                                                item?.blocklist_numbers_campaigns
                                                  .length -
                                                1
                                                ? ""
                                                : "1px solid rgb(222, 226, 230)",
                                          }}
                                        >
                                          <div className="text-center w-50">
                                            {campaign?.sms_campaign?.name}
                                          </div>
                                        </div>
                                      )
                                    )}
                                  </div>
                                </td>
                                <td>
                                  <div className="w-100">
                                    {item?.blocklist_numbers_campaigns?.map(
                                      (campaign, i) => (
                                        <div
                                          className="w-100 d-flex justify-content-center"
                                          style={{
                                            borderBottom:
                                              i ===
                                                item?.blocklist_numbers_campaigns
                                                  .length -
                                                1
                                                ? ""
                                                : "1px solid rgb(222, 226, 230)",
                                          }}
                                        >
                                          <div className="text-center w-50">
                                            {campaign?.block_by === 1
                                              ? "Admin"
                                              : campaign?.block_by === 2
                                                ? "User"
                                                : campaign?.block_by === 3
                                                  ? "System"
                                                  : "Other"}
                                          </div>
                                        </div>
                                      )
                                    )}
                                  </div>
                                </td>
                                <td>
                                  <div className="w-100">
                                    {item?.blocklist_numbers_campaigns?.map(
                                      (campaign, i) => (
                                        <div
                                          className="w-100 d-flex justify-content-center"
                                          style={{
                                            borderBottom:
                                              i ===
                                                item?.blocklist_numbers_campaigns
                                                  .length -
                                                1
                                                ? ""
                                                : "1px solid rgb(222, 226, 230)",
                                          }}
                                        >
                                          <div className="text-center w-50">
                                            {campaign?.user ? (
                                              <>
                                                <p className="mb-0">
                                                  {campaign?.user?.name}
                                                </p>
                                                <small className="mb-0">
                                                  {campaign?.user?.email}
                                                </small>
                                              </>
                                            ) : (
                                              " - "
                                            )}
                                          </div>
                                        </div>
                                      )
                                    )}
                                  </div>
                                </td>
                                <td className="text-center">
                                  {formatDate(item?.createdAt)}
                                </td>
                                <td className="text-center">
                                  {formatDate(item?.updatedAt)}
                                </td>

                                <td className="text-center">
                                  <button
                                    onClick={() => UpdateIprecord(item?.id!)}
                                    className="ms-1 bg-transparent border-0 text-primary fs-5"
                                  >
                                    <i
                                      data-tooltip-id={"Update_Btn_" + index}
                                      className="fa-solid fa-pen"
                                    ></i>
                                    <HelpText
                                      id={"Update_Btn_" + index}
                                      content="Update Block List"
                                    />
                                  </button>
                                  <button
                                    onClick={() => openDeleteModal(item?.id!)}
                                    className="ms-1 bg-transparent border-0 text-danger fs-5"
                                  >
                                    <i
                                      data-tooltip-id={"Delete_Btn_" + index}
                                      className="fa-solid fa-trash"
                                    ></i>
                                    <HelpText
                                      id={"Delete_Btn_" + index}
                                      content="Delete Block List"
                                    />
                                  </button>
                                </td>
                              </tr>
                            ))
                          )}
                        </tbody>
                      </table>
                    </div>

                    {!blocklistdata || blocklistdata.length === 0 ? (
                      <div></div>
                    ) : (
                      <div className="pagination d-flex flex-wrap justify-content-center align-items-center my-4 mx-3">
                        <RenderPaginationButtons
                          info={info}
                          currentPage={currentPage}
                          handlePageChange={handlePageChange}
                        />
                      </div>
                    )}
                  </>
                </div>
              </div>
            </div>
          </section>

          <Modal show={showDeleteModal} onHide={closeDeleteModal} centered>
            <div className="p-3">
              <div className="text-center">
                <i
                  style={{ fontSize: "50px" }}
                  className="fs-1 text-danger bi bi-info-circle"
                ></i>
              </div>
              <Modal.Header className="d-block border-0 p-2 text-center">
                <Modal.Title>Confirm Delete</Modal.Title>
              </Modal.Header>
              <Modal.Body className="border-0 text-center p-2">
                Are you sure you want to delete this BlockList Number.
              </Modal.Body>
              <Modal.Footer className="border-0 justify-content-center">
                <button className="btn btn-danger" onClick={confirmDelete}>
                  Delete
                </button>
                <button
                  className="btn btn-secondary"
                  onClick={closeDeleteModal}
                >
                  Cancel
                </button>
              </Modal.Footer>
            </div>
          </Modal>

          <AddBlockListModal
            show={showAddAllowIpModal}
            onHide={closeaddAllowIprecordModal}
          />

          <UpdateBlockListModal
            show={showUpdateAllowIpModal}
            onHide={closeUpdateAllowIprecordModal}
            selectedId={selectedId}
            currentBlockListData={currentblockListData}
          />
        </div>
      </div>
    </>
  );
}

export default Blocklist;
